(() => {
  const CUSTOM_ELEMENT_NAME = 'ag-reviews';
  const SLIDER_SELECTOR = '[data-ag-reviews-slider]';
  const PAGINATION_SELECTOR = '[data-ag-reviews-pagination]';
  const MOBILE_MEDIA_QUERY = '(max-width: 989px)';
  const MOBILE_SPACE_BETWEEN = 24;
  const INITIALIZED_DATA_KEY = 'agReviewsInitialized';

  if (customElements.get(CUSTOM_ELEMENT_NAME)) {
    window.initAgReviews?.();
    return;
  }

  class AgReviews extends HTMLElement {
    constructor() {
      super();
      this.breakpoint = window.matchMedia(MOBILE_MEDIA_QUERY);
      this.slider = null;
      this.pagination = null;
      this.swiper = null;
      this.isInitialized = false;
      this.visibility = null;

      this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
      this.handleWindowLoad = this.handleWindowLoad.bind(this);
    }

    connectedCallback() {
      if (this.isInitialized) {
        return;
      }

      this.isInitialized = true;
      this.slider = this.querySelector(SLIDER_SELECTOR);
      this.pagination = this.querySelector(PAGINATION_SELECTOR);

      this.breakpoint.addEventListener('change', this.handleBreakpointChange);
      window.addEventListener('load', this.handleWindowLoad);
      this.visibility = window.AGSliderVisibility ? new window.AGSliderVisibility(this, () => this.sync()) : null;
      this.sync();
    }

    disconnectedCallback() {
      if (!this.isInitialized) {
        return;
      }

      this.breakpoint.removeEventListener('change', this.handleBreakpointChange);
      window.removeEventListener('load', this.handleWindowLoad);
      this.visibility?.disconnect();
      this.visibility = null;
      this.destroySwiper();

      this.slider = null;
      this.pagination = null;
      this.isInitialized = false;
    }

    handleBreakpointChange() {
      this.sync();
    }

    handleWindowLoad() {
      this.sync();
    }

    sync() {
      if (!this.isInitialized || !this.slider) {
        return;
      }

      const currentInstance = this.getCurrentInstance();

      if (this.breakpoint.matches && !currentInstance) {
        this.createSwiper();
        return;
      }

      if (!this.breakpoint.matches && currentInstance) {
        this.destroySwiper();
      }
    }

    getCurrentInstance() {
      const existingInstance = this.swiper || this.slider?.swiper || null;

      if (existingInstance?.destroyed) {
        this.swiper = null;
        this.slider.dataset[INITIALIZED_DATA_KEY] = 'false';
        return null;
      }

      if (existingInstance) {
        this.swiper = existingInstance;
      }

      return existingInstance;
    }

    createSwiper() {
      if (this.visibility && !this.visibility.ready) return;
      if (!this.slider || !this.pagination || typeof window.Swiper === 'undefined') {
        return;
      }

      this.slider.dataset[INITIALIZED_DATA_KEY] = 'true';
      this.swiper = new window.Swiper(this.slider, {
        slidesPerView: 'auto',
        spaceBetween: MOBILE_SPACE_BETWEEN,
        watchOverflow: true,
        pagination: {
          el: this.pagination,
          clickable: true,
        },
      });
    }

    destroySwiper() {
      const currentInstance = this.getCurrentInstance();

      if (currentInstance && !currentInstance.destroyed) {
        currentInstance.destroy(true, true);
      }

      if (this.slider) {
        this.slider.dataset[INITIALIZED_DATA_KEY] = 'false';
      }
      this.swiper = null;
    }
  }

  const getComponents = (root = document) => {
    const components = [];

    if (root.matches?.(CUSTOM_ELEMENT_NAME)) {
      components.push(root);
    }

    root.querySelectorAll?.(CUSTOM_ELEMENT_NAME).forEach((component) => components.push(component));
    return components;
  };

  window.agReviewsBooted = true;
  window.initAgReviews = (root = document) => {
    getComponents(root).forEach((component) => component.sync());
  };

  customElements.define(CUSTOM_ELEMENT_NAME, AgReviews);
})();
